import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import NodeEntity from '@/common/models/node-entitiy'
import EmergoRequest from '@/emergo/models/emergo'
import EmergoService from '@/emergo/services/emergo-service'
import EmergoResponse from '@/emergo/models/emergo_response'

@Component
export default class EmergoDialog extends Vue {
  @Ref()
  protected validator!: ValidationObserver

  private emergoModel = new EmergoRequest('', '', '', '', '', [], 'informative')

  private node: NodeEntity | null = null
  private dialog: boolean = false
  private loading: boolean = false

  private response_informative: string = ''
  private response_reactive: string = ''

  private select_informative = false
  private select_reactive = false

  public open(u_title: string, u_description: string, node: NodeEntity) {
    this.emergoModel.name_ui_view = u_title
    this.emergoModel.context_view = u_description
    this.emergoModel.name_view_item = node.name
    this.node = node
    this.dialog = true
  }

  private async generate() {
    if (!(await this.validator.validate())) {
      return
    }

    this.loading = true

    this.response_informative = ''
    this.response_reactive = ''

    this.select_informative = false
    this.select_reactive = false

    this.emergoModel.response_style = 'proaktiv'
    let result = (await EmergoService.sendAsync(
      this.emergoModel
    )) as EmergoRequest
    if (result) {
      this.emergoModel = result
      this.response_informative = result.response_json.mistral_medium
      // console.log(JSON.stringify(result))
    }

    this.emergoModel.response_style = 'reaktiv'
    result = (await EmergoService.sendAsync(this.emergoModel)) as EmergoRequest
    if (result) {
      this.emergoModel = result
      this.response_reactive = result.response_json.mistral_medium
    }

    this.emergoModel.targetAudienceOptions = [
      'Fachöffentlichkeit/Fachexpert:innen',
      'Formierte Bürger:innen (im Sinne von Bürgerinitiativen o.ä.)',
      'Bevölkerung',
      'Anrainer:innen',
      'Wirtschaft (Unternehmen & Organisationen)',
      'Gemeinde',
      'Bildung',
      'Öffentliche Einrichtungen (Verwaltung, Gesundheit, Kultur etc.)',
      'Region',
      'Medien',
      'NGOs',
      'Politik',
      'Interessensvertretung/Verein',
      'Sonstige',
    ]

    this.loading = false
  }

  private accept() {
    const response = new EmergoResponse()
    if (this.select_informative) {
      response.response_informative = this.response_informative
    }

    if (this.select_reactive) {
      response.response_reactive = this.response_reactive
    }

    this.$bus.$emit('emergo:response', response)

    this.dialog = false
  }

  private cancel() {
    this.dialog = false
  }
}
